import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCard,
    {
      staticClass: "text-center d-flex flex-column align-center ",
      staticStyle: { height: "650px" },
    },
    [
      _c(VImg, {
        staticClass: "mt-9",
        attrs: {
          src: require("@/assets/icons/states/" + _vm.state + ".png"),
          "max-height": "350",
          "max-width": "500",
        },
      }),
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _c(
        VRow,
        { staticClass: "justify-center" },
        [
          _c(VCol, { attrs: { cols: "9" } }, [
            _c("h6", [_vm._v(_vm._s(_vm.subtitle))]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }